import React, { FC, useState } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";

type PropsType = {
  text: string;
  onClick?: () => void;
  disabled?: any;
  type?: "button" | "submit" | "reset";
};
export const VerificationBtn: FC<PropsType> = ({
  text,
  onClick,
  disabled,
  type = "button",
}) => {
  const { t } = useTranslation("onboarding-auth");

  return (
    <button
      className="verification-btn"
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {text}
    </button>
  );
};
